var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "checkout-processing-overlay",
          attrs: {
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true",
            "aria-busy": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "checkout-processing-overlay-content" },
            [
              _c("loading-animation"),
              _vm._v(" "),
              _c("p", { staticClass: "checkout-processing-overlay-message" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$translate("Ceres::Template.checkoutProcessingOrder")
                    ) +
                    "\n        "
                ),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }